// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/icon/overiew-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/icon/portfolio-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/icon/transactions-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/icon/top-buyers-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/icon/user-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/icon/password-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/icon/logout-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 280px;
  background-color: #f8f9fa;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-text {
  font-size: 18px;
  font-weight: bold;
  color: #3b82f6;
}

.menu-section {
  flex: 1 1;
  padding: 20px 0;
}

.menu-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 16px;
  font-weight: 600;
  color: #374151;
}

.collapse-icon {
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
}

.nav-menu {
  display: flex;
  flex-direction: column;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-left: 3px solid transparent;
}

.nav-item:hover {
  background-color: #f3f4f6;
}

.nav-item.active {
  background-color: #eff6ff;
  border-left-color: #3b82f6;
  color: #1d4ed8;
}

.nav-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-icon.bar-chart {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.nav-icon.folder {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.nav-icon.arrows {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.nav-icon.trophy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.nav-label {
  font-size: 14px;
  font-weight: 500;
}

.user-section {
  padding: 20px;
  border-top: 1px solid #e5e7eb;
}

.user-info {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 8px 0;
}

.user-icon {
  margin-right: 8px;
  font-size: 16px;
  width: 16px;
  height: 16px;
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.username {
  font-weight: 500;
  color: #374151;
}

.user-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;
  color: #6b7280;
  font-size: 14px;
  transition: color 0.2s;
}

.action-item:hover {
  color: #374151;
}

.action-item.logout {
  color: #ef4444;
}

.action-item.logout:hover {
  color: #dc2626;
}

.action-icon {
  margin-right: 8px;
  font-size: 14px;
  width: 14px;
  height: 14px;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.action-icon.password {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.action-icon.logout {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid #e5e7eb;
  margin-top: auto;
}

.footer-logo {
  margin-bottom: 12px;
}

.footer-logo-text {
  font-size: 16px;
  font-weight: bold;
  color: #3b82f6;
}

.copyright {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
}

.copyright p {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yDAA2D;EAC3D,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yDAA6D;EAC7D,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yDAAgE;EAChE,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yDAA8D;EAC9D,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yDAAwD;EACxD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yDAA4D;AAC9D;;AAEA;EACE,yDAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".sidebar {\n  width: 280px;\n  background-color: #f8f9fa;\n  border-right: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow-y: auto;\n}\n\n.sidebar-header {\n  padding: 20px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n}\n\n.logo-text {\n  font-size: 18px;\n  font-weight: bold;\n  color: #3b82f6;\n}\n\n.menu-section {\n  flex: 1;\n  padding: 20px 0;\n}\n\n.menu-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px 16px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.collapse-icon {\n  font-size: 16px;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.nav-menu {\n  display: flex;\n  flex-direction: column;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  padding: 12px 20px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  border-left: 3px solid transparent;\n}\n\n.nav-item:hover {\n  background-color: #f3f4f6;\n}\n\n.nav-item.active {\n  background-color: #eff6ff;\n  border-left-color: #3b82f6;\n  color: #1d4ed8;\n}\n\n.nav-icon {\n  width: 20px;\n  height: 20px;\n  margin-right: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nav-icon.bar-chart {\n  background-image: url('../../public/icon/overiew-icon.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.nav-icon.folder {\n  background-image: url('../../public/icon/portfolio-icon.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.nav-icon.arrows {\n  background-image: url('../../public/icon/transactions-icon.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.nav-icon.trophy {\n  background-image: url('../../public/icon/top-buyers-icon.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.nav-label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.user-section {\n  padding: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n  padding: 8px 0;\n}\n\n.user-icon {\n  margin-right: 8px;\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  background-image: url('../../public/icon/user-icon.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.username {\n  font-weight: 500;\n  color: #374151;\n}\n\n.user-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.action-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n  cursor: pointer;\n  color: #6b7280;\n  font-size: 14px;\n  transition: color 0.2s;\n}\n\n.action-item:hover {\n  color: #374151;\n}\n\n.action-item.logout {\n  color: #ef4444;\n}\n\n.action-item.logout:hover {\n  color: #dc2626;\n}\n\n.action-icon {\n  margin-right: 8px;\n  font-size: 14px;\n  width: 14px;\n  height: 14px;\n  display: inline-block;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.action-icon.password {\n  background-image: url('../../public/icon/password-icon.png');\n}\n\n.action-icon.logout {\n  background-image: url('../../public/icon/logout-icon.png');\n}\n\n.sidebar-footer {\n  padding: 20px;\n  border-top: 1px solid #e5e7eb;\n  margin-top: auto;\n}\n\n.footer-logo {\n  margin-bottom: 12px;\n}\n\n.footer-logo-text {\n  font-size: 16px;\n  font-weight: bold;\n  color: #3b82f6;\n}\n\n.copyright {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.copyright p {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
